import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ICompanyItemCardData } from 'app/common/ui/k-cards/k-company-item-card/k-company-item-card.interface';
import { ICompanyItemsResponse } from 'app/services/companyItems/company-items.interface';
import { CompanyItemsService } from 'app/services/companyItems/company-items.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'app-company-store',
  templateUrl: './company-store.component.html',
  styleUrls: ['./company-store.component.scss']
})
export class CompanyStoreComponent implements OnInit {
  
  wallet: string;
  companyItemsData: ICompanyItemsResponse[] = [];

  constructor(
    private userService: UserService,
    private companyItemsService: CompanyItemsService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.wallet = this.userService._userInfoData.recordedWallet;
    //companyItems$ is fullfilled by userlayout
    this.companyItemsService.companyItems$.subscribe(
      items => {
        this.companyItemsData = items;
      }
    );
  }

  onCardClick(event: ICompanyItemCardData): void {
    this.router.navigate(['./primus-bazaar/company-store/', event.id]);
  }
}
